class PrioVersand extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');

    if (!this.checkbox) {
      return;
    }

    this.busy = false;
    this.abortController = new AbortController();

    this.checkbox.addEventListener("change", this.onToggle.bind(this));
    document.addEventListener(
      "cart:change",
      (event) => this.syncFromCart(event.detail.cart),
      { signal: this.abortController.signal }
    );
    document.addEventListener("cart:refresh", () => this.syncFromCart(), {
      signal: this.abortController.signal,
    });

    this.syncFromCart();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  get variantId() {
    return this.getAttribute("data-variant-id");
  }

  findLineItem(cart) {
    return cart.items.find(
      (item) => item.properties && item.properties["_prio_versand"] === "true"
    );
  }

  async fetchCart() {
    const response = await fetch(`${Shopify.routes.root}cart.js`);
    return response.json();
  }

  async syncFromCart(cart) {
    if (this.busy) {
      return;
    }

    this.checkbox.checked = Boolean(this.findLineItem(cart || (await this.fetchCart())));
  }

  collectBundledSections() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections },
      })
    );
    return sections;
  }

  async onToggle(event) {
    const checked = event.target.checked;
    this.busy = true;
    this.checkbox.disabled = true;

    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    if (checked) {
      await this.addTurboVersand();
    } else {
      await this.removeTurboVersand();
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );

    this.checkbox.disabled = false;
    this.busy = false;
  }

  async addTurboVersand() {
    if (!this.variantId) {
      console.warn(
        "prio-versand: keine data-variant-id gesetzt, Turbo-Versand-Produkt kann nicht hinzugefügt werden."
      );
      this.checkbox.checked = false;
      return;
    }

    const sections = this.collectBundledSections();
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: this.variantId,
            quantity: 1,
            properties: { _prio_versand: "true" },
          },
        ],
        sections: sections.join(","),
      }),
    });

    if (!response.ok) {
      this.checkbox.checked = false;
      return;
    }

    const responseJson = await response.json();
    const cart = await this.fetchCart();
    cart["sections"] = responseJson["sections"];

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "variant:add", cart },
      })
    );
  }

  async removeTurboVersand() {
    const cart = await this.fetchCart();
    const lineItem = this.findLineItem(cart);

    if (!lineItem) {
      return;
    }

    const sections = this.collectBundledSections();
    const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: lineItem.key,
        quantity: 0,
        sections: sections.join(","),
      }),
    });

    if (!response.ok) {
      this.checkbox.checked = true;
      return;
    }

    const cartContent = await response.json();

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "line-item:change", cart: cartContent },
      })
    );
  }
}

if (!window.customElements.get("prio-versand")) {
  window.customElements.define("prio-versand", PrioVersand);
}
